export default "__VITE_ASSET__27c94492__"